<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import BaseIcon from '@/components/ui/BaseIcon.vue';
import { shareLink } from '@/libs/share';
import { useAppStore } from '@/stores/app';

const props = defineProps<{
  title: string;
  url: string;
}>();

const appStore = useAppStore();
const { t } = useI18n();

async function share() {
  try {
    const outcome = await shareLink({ title: props.title, url: props.url });
    if (outcome === 'copied') appStore.showToast(t('share.linkCopied'), 'check');
  } catch {
    appStore.showToast(t('share.failed'), 'circle-alert');
  }
}
</script>

<template>
  <button class="share-button" type="button" :aria-label="t('share.label')" @click.prevent="share">
    <BaseIcon name="share-2" class="share-button__icon" />
  </button>
</template>

<style lang="scss" scoped>
.share-button {
  align-items: center;
  background: none;
  border: 0;
  color: $color-neutral-highest;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  padding: 10px;
  position: relative;

  &__icon {
    font-size: 16px;
  }

  // Widens the tap target past the icon's visual bounds without affecting the layout.
  &::after {
    content: '';
    inset: -8px;
    position: absolute;
  }
}
</style>
